export type ChatIdMapping = Record<string, string>

/**
 * Reverse lookup of the temp→real chat-id mapping: a chat created this
 * session keeps its temp id as its render identity, so the temp→real swap on
 * the first `metadata` event never changes this value and the message list is
 * not remounted mid-stream. The mapping is trimmed to 20 entries — a chat
 * kept open while 20 newer chats are created elsewhere sees its key flip once
 * (one remount, with no stream active in that window in practice).
 */
export function stableConversationKey(mapping: ChatIdMapping, chatId: string): string {
  for (const [tempId, realId] of Object.entries(mapping)) {
    if (realId === chatId) {
      return tempId
    }
  }
  return chatId
}
